import React from "react";
import PropTypes from "prop-types";

const Alert = ({ children }) => {
  return (
    <div
      style={{ borderWidth: 1 }}
      className="rounded-md bg-blue-50 py-3 px-4 border-blue-200"
    >
      <div className="flex">
        <div className="flex-shrink-0">
          <svg
            className="h-5 w-5 text-blue-400"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <div className="ml-3 flex-1 md:flex md:justify-between">
          <p className="text-sm leading-5 text-blue-700">{children}</p>
        </div>
      </div>
    </div>
  );
};

Alert.propTypes = {
  children: PropTypes.node.isRequired
};

export default Alert;
